export class VersionInfoDto {
    name: string;
    version: string;
    buildTime: string;
    commit: string;

    constructor(src: Partial<VersionInfoDto>) {
        this.name = src.name || '';
        this.version = src.version || '';
        this.buildTime = src.buildTime || '';
        this.commit = src.commit || '';
    }
}
